module.exports = __webpack_public_path__ + "static/media/circle.211a49b6.svg";